import(/* webpackMode: "eager" */ "/app/src/pageComponents/proposal-create/_page.tsx")